export const CHARTDATA = {
  credits: { enabled: false },
  chart: {
    type: "column"
  },
  title: {
    text: "Stacked column chart"
  },
  xAxis: {
    categories: ["All", "North", "East", "West", "South"]
  },
  yAxis: {
    min: 0,
    title: {
      text: "Total fruit consumption"
    },
    stackLabels: {
      enabled: true,
      style: {
        fontWeight: "bold"
      }
    }
  },
  legend: {
    align: "right",
    x: -30,
    verticalAlign: "top",
    y: 25,
    floating: true,
    borderColor: "#CCC",
    borderWidth: 1,
    shadow: false
  },
  tooltip: {
    headerFormat: "<b>{point.x}</b><br/>",
    pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}"
  },
  plotOptions: {
    column: {
      stacking: "normal",
      dataLabels: {
        enabled: true
      }
    }
  },
  series: [{ showInLegend: false, data: [5, 3, 4, 7, 2] }]
};
